export const education = [
    {
        id: 'uwu',
        period: 'Mar 2016 — Mar 2020',
        level: 'Bachelor of Science · Honours',
        program: 'Industrial Information Technology',
        institution: 'Uva Wellassa University',
        location: 'Sri Lanka',
        detail:
            'A 4-year, 120-credit English-medium degree covering software engineering, algorithms, databases, web applications, networks, business intelligence, project management and research.',
        tags: ['Software engineering', 'Algorithms', 'Databases', 'Research'],
    },
    {
        id: 'nalanda-al',
        period: 'Aug 2014',
        level: 'G.C.E. Advanced Level',
        program: 'Commerce Stream',
        institution: 'Nalanda College, Colombo',
        location: 'Sri Lanka',
        detail: 'Accounting - A · Business Studies - B · Information & Communication Technology - C.',
        tags: ['Accounting · A', 'Business Studies · B', 'ICT · C'],
    },
    {
        id: 'nalanda-git',
        period: 'Aug 2013',
        level: 'General Information Technology',
        program: 'General Information Technology Examination',
        institution: 'Nalanda College, Colombo',
        location: 'Sri Lanka',
        detail: 'Result: A · English medium.',
        tags: ['English medium', 'Result · A'],
    },
];

export const awards = [
    {
        id: 'smart-sri-lanka',
        title: 'Mobitel Smart Sri Lanka Hackathon',
        detail: '1st Runner Up in a national hackathon focused on building useful technology solutions.',
        meta: 'Mobitel and Sri Lanka Telecom',
    },
    {
        id: 'uwu-gamejam',
        title: 'UWU GameJam',
        detail: '1st place for a game development project created through the Uva Wellassa University community.',
        meta: 'Mozilla Campus Club · 2018',
    },
    {
        id: 'deft-coders',
        title: 'Deft-coders 12-hour hackathon',
        detail: 'Placed 3rd in 2016 and 5th in 2018 while competing in rapid, team-based software development.',
        meta: 'Computer Society · Uva Wellassa University',
    },
    {
        id: 'cert-quiz',
        title: 'Cyber Security Quiz Competition',
        detail: 'Placed 7th in a national cybersecurity-focused competition.',
        meta: 'Sri Lanka CERT|CC · 2019',
    },
    {
        id: 'innovation',
        title: 'Innovation competitions',
        detail: 'Participated in SAHASAK NIMAVUM and Maker Fair, exploring new ideas through hands-on engineering.',
        meta: 'Provincial 2019 · Kandy 2018',
    },
    {
        id: 'deft-v6',
        title: 'Deft-coders v6.0',
        detail: 'Organized a 12-hour hackathon for student developers and makers.',
        meta: 'Computer Society · Uva Wellassa University',
    },
];

export const activities = [
    {
        id: 'compsoc',
        title: 'Computer Society leadership',
        detail: 'Vice president and professional-development program coordinator, helping create opportunities for student builders.',
        meta: 'Uva Wellassa University · 2018',
    },
    {
        id: 'ieee',
        title: 'IEEE Student Branch',
        detail: 'Served as a first-year student coordinator and student representative for the IIT batch.',
        meta: 'Uva Wellassa University · 2017',
    },
    {
        id: 'sports',
        title: 'University sports',
        detail: 'Played for the university volleyball team and karate team, including participation in the Sri Lanka University Games.',
        meta: 'SLUG · 2017',
    },
    {
        id: 'school-lead',
        title: 'School leadership and sport',
        detail: 'Senior prefect, Under-19 volleyball vice-captain, and member of the handball, cricket and carom teams.',
        meta: 'Nalanda College · 2012 - 2014',
    },
    {
        id: 'community',
        title: 'Community and event work',
        detail: 'Coordinated the Geethma musical concert, supported the Ananda vs Nalanda Big Match committee, and contributed to the Saukyadana Unit.',
        meta: 'Nalanda College · 2013 - 2014',
    },
    {
        id: 'first-aid',
        title: 'Service and first aid',
        detail: 'Attended Emergency First Aid and Basic Life Support training while supporting school community initiatives.',
        meta: 'Nalanda College · 2013',
    },
];

export default education;
